<div class="clr-row">
  <div class="clr-col-12" *ngFor="let localTree of treeForView">
    <div class="card">
      <div class="card-header">Производствени нареждания</div>
      <div class="card-block">
        <div class="card-text">
          <clr-tree>
            <clr-tree-node *clrRecursiveFor="
                let branch of treeForView;
                getChildren: getChildrens
              " [clrExpanded]="true">
              {{ branch.node?.poNumber }}
              <div style="margin-left: 10px; width:100%">
                <table class="table table-compact" *ngFor="let i of branch.node?.itemsWithIngredients">
                  <thead>
                    <tr>
                      <th class="left">{{i?.item?.LineOrd}}</th>
                      <th class="left">{{i?.item?.Product?.Name?.BG}}</th>
                      <th class="left">{{i?.item?.ProducedQuantity?.Value}} {{i?.item?.ProducedQuantity?.Unit}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let ing of i.ingredients">
                      <td class="left">{{ing?.LineOrd}}</td>
                      <td class="left">{{ing?.Material?.Name?.BG}}</td>
                      <td class="left">{{ing?.UsedQuantity.Value}} {{ing?.UsedQuantity.Unit}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr>
            </clr-tree-node>
          </clr-tree>
        </div>
      </div>
    </div>
  </div>
</div>